import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "sendStatusBC"
})
export class SendStatusBCPipe implements PipeTransform {

  constructor(private translationService: TranslateService) {
  }

  transform(value: number): string {
    if (value === 0) {
      // Returning empty because 0 is the default value for enums in AL
      return " ";
    }


    const name = Status[value];

    if (!name) {
      return this.translationService.instant("STATUS.UNDEFINED");
    }

    return this.translationService.instant(`SendStatusBCPipe.STATUS.${name}`);
  }
}

enum Status {
  Sent = 1,
  Received = 2,
  Error = 3,
  Rejected = 4,
  Started = 5
}
